/* eslint-disable no-shadow */
/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Progress,
} from 'reactstrap';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import {
  LOCALSTORAGE_TOKEN,
} from '../../../../../utils/Types';
import renderFileInputField from '../../../../../shared/components/form/FileInput';
import {
  URL_CATEGORYCOURSE,
} from '../../../../../utils/EndPoints';

const CreateCategoryForm = () => {
  const history = useHistory();
  const [progress, setProgress] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const onSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    if (e.target.thumbnail.files[0]) {
      data.append('thumbnail', e.target.thumbnail.files[0]);
    }
    data.append('order_display', e.target.order_display.value);
    data.append('name', e.target.name.value);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      onUploadProgress: (data) => {
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    axios
      .post(URL_CATEGORYCOURSE, data, options)
      .then(() => {
        messageApi.success('New Topic Successfully Created');
        history.push('/admin/topic');
      })
      .catch(() => {
        messageApi.error('New Topic Failed Created');
      });
  };

  const imageHandler = () => {
    if (thumbnail) {
      return thumbnail;
    }
    return '/img/no_image.png';
  };

  const inputImageHandler = (e) => {
    setThumbnail(URL.createObjectURL(e.file));
    const conditions = ['image/png', 'image/jpg', 'image/jpeg'];

    if (!conditions.some((el) => e.file.type.includes(el))) {
      messageApi.open({
        type: 'error',
        content: 'Only image file types allowed',
      });
    }
  };

  return (
    <Col md={12} lg={12}>
      {contextHolder}
      <ButtonToolbar className="form__button-toolbar">
        <Button size="sm" color="danger" onClick={history.goBack}>
          Back
        </Button>
      </ButtonToolbar>
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <div className="card__title">
            <h5 className="bold-text">Create New Topic</h5>
          </div>
          <form className="form" onSubmit={onSubmit}>
            <img src={imageHandler()} alt="" className="testimonial-image" />
            <span className="form__form-group-label">Thumbnail</span>
            <div className="form__form-group">
              <div className="form__form-group-field mb-0-label">
                <Field
                  name="thumbnail"
                  component={renderFileInputField}
                  required
                  onChange={(e) => { inputImageHandler(e); }}
                />
              </div>
            </div>
            <span className="form__form-group-label">Topic Order</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="order_display"
                  component="input"
                  type="number"
                  min={0}
                  placeholder="Topic order"
                  required
                />
              </div>
            </div>
            <span className="form__form-group-label">Name</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="name"
                  component="input"
                  type="text"
                  placeholder="Name"
                  required
                />
              </div>
            </div>

            {progress !== null && (
              <Card>
                <Col md={12} lg={12}>
                  <Progress animated value={progress}>{progress}%</Progress>
                </Col>
              </Card>
            )}

            <ButtonToolbar className="form__button-toolbar">
              <Button
                color="primary"
                type="submit"
              >
                Submit
              </Button>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default reduxForm({
  form: 'CreateELibrary_form', // a unique identifier for this form
})(CreateCategoryForm);
